import flatten from 'lodash/flatten';

export const flattenChefs = allPresets =>
  flatten(allPresets.map(presetCategory => presetCategory[1]));

const DAY_NAMES = [
  'sunday',
  'monday',
  'tuesday',
  'wednesday',
  'thursday',
  'friday',
  'saturday',
];

export const isRestaurantOpenNow = (storeHours, now = new Date()) => {
  if (!storeHours) return true;
  const today = storeHours[DAY_NAMES[now.getDay()]];
  if (!today || today.enabled === false || !today.open || !today.close) {
    return false;
  }
  const [openHour, openMinute] = today.open.split(':').map(Number);
  const [closeHour, closeMinute] = today.close.split(':').map(Number);
  const minutesNow = now.getHours() * 60 + now.getMinutes();
  const openMinutes = openHour * 60 + openMinute;
  const closeMinutes = closeHour * 60 + closeMinute;
  return minutesNow >= openMinutes && minutesNow <= closeMinutes;
};

export const getOrderNoticeLabel = noticeHours => {
  if (!noticeHours || noticeHours <= 0) return 'Order anytime';
  if (noticeHours < 24) return `${noticeHours}h notice`;
  const days = Math.round(noticeHours / 24);
  return `${days} day${days > 1 ? 's' : ''} notice`;
};
